<template>
	<div class="content">
		<div class="content-assets">
			<div class="flex-cement">
				<div class="cement1">账户资金日志</div>
			</div>
			<div class="border-top"></div>
			<el-table :data="tableData" style="width: 100%">
				<el-table-column prop="categoryName" label="日期" min-width="150">
					<template v-slot="{ row }">
						<div>{{formatTime(row.createTime)}}</div>
					</template>
				</el-table-column>
				<el-table-column prop="description" label="操作类型" min-width="150" />
				<el-table-column prop="beforeAmount" label="变动前金额" min-width="150" />
				<el-table-column label="变动金额" min-width="150">
					<template v-slot="{ row }">
						<div v-if="row.type == 10" style="color: #5DC799;">+{{row.amount}}</div>
						<div v-else style="color: #D2502C;">-{{row.amount}}</div>
					</template>
				</el-table-column>
				<el-table-column prop="afterAmount" label="变动后金额" min-width="150" />
				<el-table-column prop="recordId" label="关联订单" min-width="150" />
			</el-table>
			<div class="pagination">
				<el-pagination @size-change="sizeChange" @current-change="currentChange" background
					:page-sizes='[10,20,30,40,50]' layout="total, sizes, prev, pager, next, jumper" :total="total" />
			</div>
		</div>
	</div>
</template>

<script setup>
	import {
		onMounted,
		reactive,
		ref
	} from 'vue';
	import {
		merchantOrderPage,
		merchantCardCategory,
		merchantCallbackOrder,
		orderExportExcel,
		merchanRecordPage
	} from '@/utils/api.js';
	import dayjs from 'dayjs';

	let ids = ref(1);
	let formInline = reactive({
		pageSize: 10,
		pageNo: 1,
		cardBody: null,
		status: null,
	})
	let idDataLisrt = ref(0)
	let tableData = ref([]);
	let total = ref(0);
	let dataList = ref([{
			id: 1,
			title: '今天'
		},
		{
			id: 2,
			title: '昨天'
		},
		{
			id: 3,
			title: '近7天'
		},
		{
			id: 4,
			title: '一个月'
		}
	]);
	let startTimeDate = ref();
	let detailsOrder = ref({});
	let listObj = ref([]);

	const onSubmit = () => {
		formInline.pageNo = 1;
		if (startTimeDate.value) {
			formInline.startTime = startTimeDate.value[0];
			formInline.endTime = startTimeDate.value[1];
		} else {
			idDataLisrt.value = 0;
			formInline.startTime = null;
			formInline.endTime = null;
		}
		formInline.memberUserId = userInfo.value.id;
		merchanRecordPage(formInline).then(res => {
			tableData.value = res.data.list
			total.value = res.data.total;
		})
	}

	function infoCategory() {
		merchantCardCategory().then(res => {
			listObj.value = res.data;
		})
	}

	function exportExcel() {
		orderExportExcel().then(res => {
			const url = window.URL.createObjectURL(new Blob([res.data]));
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', 'data.xlsx');
			document.body.appendChild(link);
			link.click();
		})
	}

	function reissueNotice(item) {
		console.log(item.id)
		let orderIdList = [];
		orderIdList.push(item.id);
		merchantCallbackOrder({
			orderIdList,
		}).then(res => {
			console.log(res)
		})
	}

	function timeClick(item) {
		idDataLisrt.value = item.id;
		if (item.title == '今天') {
			showTodayTime();
		} else if (item.title == '昨天') {
			showYesterdayTime();
		} else if (item.title == "近7天") {
			showLast7DaysTime();
		} else {
			showOneMonthTime();
		}
	}

	function showOneMonthTime() {
		// 开始时间：今天0点
		const startDate = new Date();
		startDate.setHours(0, 0, 0, 0);

		// 结束时间：一个月后23点59分59秒
		const endDate = new Date();
		endDate.setMonth(endDate.getMonth() - 1); // 月份加1
		endDate.setHours(23, 59, 59, 999);

		// 格式化并设置时间范围
		let start = formatDate(startDate);
		let end = formatDate(endDate);

		startTimeDate.value = [];
		startTimeDate.value.push(start);
		startTimeDate.value.push(end);
	}

	function showLast7DaysTime() {
		// 开始时间：今天0点
		const startDate = new Date();
		startDate.setHours(0, 0, 0, 0);

		// 结束时间：7天后0点
		const endDate = new Date();
		endDate.setDate(endDate.getDate() - 7);
		endDate.setHours(23, 59, 59, 999);

		// 格式化并设置时间范围
		let start = formatDate(startDate);
		let end = formatDate(endDate);

		startTimeDate.value = [];
		startTimeDate.value.push(start);
		startTimeDate.value.push(end);
	}

	function showTodayTime() {
		const today = new Date();
		setTimeRange(today);
	}

	function showYesterdayTime() {
		const yesterday = new Date();
		yesterday.setDate(yesterday.getDate() - 1);
		setTimeRange(yesterday);
	}


	// 格式化日期为 YYYY-MM-DD HH:mm:ss 格式
	function formatDate(date) {
		const year = date.getFullYear();
		const month = padZero(date.getMonth() + 1); // 月份从0开始，需+1
		const day = padZero(date.getDate());
		const hours = padZero(date.getHours());
		const minutes = padZero(date.getMinutes());
		const seconds = padZero(date.getSeconds());

		return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
	}

	function setTimeRange(date) {
		const year = date.getFullYear();
		const month = padZero(date.getMonth() + 1); // 月份从0开始，需+1
		const day = padZero(date.getDate());

		// 设置开始和结束时间
		let start = `${year}-${month}-${day} 00:00:00`;
		let end = `${year}-${month}-${day} 23:59:59`;
		startTimeDate.value = [];
		startTimeDate.value.push(start);
		startTimeDate.value.push(end);
	}

	function padZero(num) {
		return num < 10 ? `0${num}` : num;
	}

	function currentChange(item) {
		formInline.pageNo = item;
		onSubmit1();
	}

	const pickedStartDate = ref(null);
	// 处理日历变化事件
	const handleCalendarChange = (value) => {
		console.log('calendar-change', value);

		if (value && Array.isArray(value)) {
			const [startDate, endDate] = value;

			if (startDate && !endDate) {
				// 用户选择了开始日期，但还没选择结束日期，将选择的日期储存，用于禁用日期的判断
				pickedStartDate.value = new Date(startDate);
				console.log('开始日期选择:', pickedStartDate.value);
			} else {
				// 清空选择
				pickedStartDate.value = null;
				console.log('清空选择');
			}
		}
	}

	// Element Plus 的禁用日期函数
	const disabledDate = (time) => {
		// 如果没有选择开始日期，不禁用任何日期
		if (!pickedStartDate.value) {
			return false;
		}

		const startYear = pickedStartDate.value.getFullYear();
		const startMonth = pickedStartDate.value.getMonth();
		const currentYear = time.getFullYear();
		const currentMonth = time.getMonth();

		// 禁用与开始日期不在同一月的日期
		return currentYear !== startYear || currentMonth !== startMonth;
	};

	function sizeChange(item) {
		formInline.pageSize = item;
		onSubmit1();
	}

	const onSubmit1 = () => {
		if (startTimeDate.value) {
			formInline.startTime = startTimeDate.value[0];
			formInline.endTime = startTimeDate.value[1];
		} else {
			formInline.startTime = null;
			formInline.endTime = null;
		}
		formInline.memberUserId = userInfo.value.id;
		console.log(111111,userInfo.value.id)
		merchanRecordPage(formInline).then(res => {
			tableData.value = res.data.list
			total.value = res.data.total;
		})
	}

	function formatTime(date) {
		return dayjs(date).format('YYYY-MM-DD');
	}

	let centerDialogVisible = ref(false);

	function details(row) {
		centerDialogVisible.value = true;
		detailsOrder.value = row;
	}

	function save() {
		centerDialogVisible.value = false;
	}
  let userInfo = ref({});
	onMounted(() => {
		userInfo.value = JSON.parse(localStorage.getItem('information'));
		onSubmit1();
		infoCategory();
	})
</script>

<style lang="scss" scoped>
	.content-assets {
		padding: 20px 21px;
	}

	.content {
		width: 85%;
		background-color: #fff;
		margin-left: 20px;
		margin-left: auto;
	}

	.flex-cement {
		position: relative;
		display: flex;
		align-items: center;

		.cement1 {
			font-family: PingFang SC, PingFang SC;
			font-weight: 600;
			font-size: 20px;
			color: #333333;
			font-style: normal;
			text-transform: none;
		}
	}

	.border-top {
		width: 99%;
		height: 0px;
		border-top: 1px solid #eeeeee;
		margin-top: 16px;
		padding-top: 16px;
	}

	.demo-form-inline .el-input {
		--el-input-width: 180px;
	}

	.demo-form-inline .el-select {
		--el-select-width: 180px;
	}

	.pagination {
		display: flex;
		justify-content: right;
		margin-top: 20px;
	}

	.flex-dialog-visible {
		display: flex;
		flex-wrap: wrap;
	}

	.orderBorder {
		width: 49%;
		border: 1px solid #E9E9E9;
		display: flex;
		align-items: center;

		.title {
			border-right: 1px solid #E9E9E9;
			width: 100px;
			padding: 10px 15px;
		}

		.text {
			margin-left: 10px;
		}
	}

	.orderBorder:nth-child(even) {
		border-left: none;
	}

	.flex-list {
		display: flex;
	}

	.dataListClick {
		border: 1px solid #ccc;
		padding: 0px 20px;
		font-size: 14px;
		margin-left: 10px;
	}

	.dataListClick:hover {
		cursor: pointer;
	}

	.dataClick {
		border: 1px solid #1884FC;
		background-color: #1884FC;
		color: #fff;
	}
</style>